{
  "HELP_CENTER": {
    "TITLE": "Centrum pomocy",
    "NEW_PAGE": {
      "DESCRIPTION": "Create self-service help center portals for your customers. Help them find answers quickly, without waiting. Streamline inquiries, boost agent efficiency, and elevate customer support.",
      "CREATE_PORTAL_BUTTON": "Utwórz portal"
    },
    "HEADER": {
      "FILTER": "Filtruj według",
      "SORT": "Sortuj według",
      "LOCALE": "Język",
      "SETTINGS_BUTTON": "Ustawienia",
      "NEW_BUTTON": "Nowy artykuł",
      "DROPDOWN_OPTIONS": {
        "PUBLISHED": "Opublikowane",
        "DRAFT": "Szkic",
        "ARCHIVED": "Zarchiwizowane"
      },
      "TITLES": {
        "ALL_ARTICLES": "Wszystkie artykuły",
        "MINE": "Moje artykuły",
        "DRAFT": "Artykuły w trakcie tworzenia",
        "ARCHIVED": "Archiwalne artykuły"
      },
      "LOCALE_SELECT": {
        "TITLE": "Select locale",
        "PLACEHOLDER": "Select locale",
        "NO_RESULT": "No locale found",
        "SEARCH_PLACEHOLDER": "Search locale"
      }
    },
    "EDIT_HEADER": {
      "ALL_ARTICLES": "Wszystkie artykuły",
      "PUBLISH_BUTTON": "Opublikuj",
      "MOVE_TO_ARCHIVE_BUTTON": "Przenieś do archiwum",
      "PREVIEW": "Podgląd",
      "ADD_TRANSLATION": "Dodaj tłumaczenie",
      "OPEN_SIDEBAR": "Otwórz panel boczny",
      "CLOSE_SIDEBAR": "Zamknij panel boczny",
      "SAVING": "Zapisywanie...",
      "SAVED": "Zapisano"
    },
    "ARTICLE_EDITOR": {
      "IMAGE_UPLOAD": {
        "TITLE": "Prześlij obraz",
        "UPLOADING": "Przesyłanie...",
        "SUCCESS": "Obraz został pomyślnie przesłany",
        "ERROR": "Błąd podczas przesyłania obrazu",
        "UN_AUTHORIZED_ERROR": "You are not authorized to upload images",
        "ERROR_FILE_SIZE": "Rozmiar obrazu powinien być mniejszy niż {size}MB",
        "ERROR_FILE_FORMAT": "Format obrazu powinien być jpg, jpeg lub png",
        "ERROR_FILE_DIMENSIONS": "Wymiary obrazu powinny być mniejsze niż 2000 x 2000"
      }
    },
    "ARTICLE_SETTINGS": {
      "TITLE": "Ustawienia artykułu",
      "FORM": {
        "CATEGORY": {
          "LABEL": "Kategoria",
          "TITLE": "Wybierz kategorię",
          "PLACEHOLDER": "Wybierz kategorię",
          "NO_RESULT": "Brak znalezionych kategorii",
          "SEARCH_PLACEHOLDER": "Szukaj kategorii"
        },
        "AUTHOR": {
          "LABEL": "Autor",
          "TITLE": "Wybierz autora",
          "PLACEHOLDER": "Wybierz autora",
          "NO_RESULT": "Brak znalezionych autorów",
          "SEARCH_PLACEHOLDER": "Szukaj autora"
        },
        "META_TITLE": {
          "LABEL": "Tytuł meta",
          "PLACEHOLDER": "Dodaj tytuł meta"
        },
        "META_DESCRIPTION": {
          "LABEL": "Opis meta",
          "PLACEHOLDER": "Dodaj opis meta dla lepszych wyników SEO..."
        },
        "META_TAGS": {
          "LABEL": "Tagi meta",
          "PLACEHOLDER": "Dodaj tagi meta oddzielone przecinkami..."
        }
      },
      "BUTTONS": {
        "ARCHIVE": "Archiwizuj artykuł",
        "DELETE": "Usuń artykuł"
      }
    },
    "ARTICLE_SEARCH_RESULT": {
      "UNCATEGORIZED": "Bez kategorii",
      "SEARCH_RESULTS": "Search results for {query}",
      "EMPTY_TEXT": "Search for articles to insert into replies.",
      "SEARCH_LOADER": "Wyszukiwanie...",
      "INSERT_ARTICLE": "Wstaw",
      "NO_RESULT": "Brak znalezionych artykułów",
      "COPY_LINK": "Skopiuj link do artykułu do schowka",
      "OPEN_LINK": "Otwórz artykuł w nowej karcie",
      "PREVIEW_LINK": "Podgląd artykułu"
    },
    "PORTAL": {
      "HEADER": "Portale",
      "DEFAULT": "Domyślny",
      "NEW_BUTTON": "Nowy portal",
      "ACTIVE_BADGE": "aktywna",
      "CHOOSE_LOCALE_LABEL": "Wybierz język",
      "LOADING_MESSAGE": "Ładowanie portalów...",
      "ARTICLES_LABEL": "artykułów",
      "NO_PORTALS_MESSAGE": "Brak dostępnych portali",
      "ADD_NEW_LOCALE": "Dodaj nowy język",
      "POPOVER": {
        "TITLE": "Portale",
        "PORTAL_SETTINGS": "Ustawienia portalu",
        "SUBTITLE": "Masz wiele portali i możesz mieć różne języki dla każdego z nich.",
        "CANCEL_BUTTON_LABEL": "Anuluj",
        "CHOOSE_LOCALE_BUTTON": "Wybierz język"
      },
      "PORTAL_SETTINGS": {
        "LIST_ITEM": {
          "HEADER": {
            "COUNT_LABEL": "artykułów",
            "ADD": "Dodaj język",
            "VISIT": "Odwiedź stronę",
            "SETTINGS": "Ustawienia",
            "DELETE": "Usuń"
          },
          "PORTAL_CONFIG": {
            "TITLE": "Konfiguracje portalu",
            "ITEMS": {
              "NAME": "Nazwa",
              "DOMAIN": "Niestandardowa domena",
              "SLUG": "Slug",
              "TITLE": "Tytuł portalu",
              "THEME": "Kolor motywu",
              "SUB_TEXT": "Tekst dodatkowy portalu"
            }
          },
          "AVAILABLE_LOCALES": {
            "TITLE": "Dostępne języki",
            "TABLE": {
              "NAME": "Nazwa języka",
              "CODE": "Kod języka",
              "ARTICLE_COUNT": "Liczba artykułów",
              "CATEGORIES": "Liczba kategorii",
              "SWAP": "Zamień",
              "DELETE": "Usuń",
              "DEFAULT_LOCALE": "Domyślny"
            }
          }
        },
        "DELETE_PORTAL": {
          "TITLE": "Usuń portal",
          "MESSAGE": "Czy na pewno chcesz usunąć ten portal",
          "YES": "Tak, usuń portal",
          "NO": "Nie, zachowaj portal",
          "API": {
            "DELETE_SUCCESS": "Portal został pomyślnie usunięty",
            "DELETE_ERROR": "Błąd podczas usuwania portalu"
          }
        },
        "SEND_CNAME_INSTRUCTIONS": {
          "API": {
            "SUCCESS_MESSAGE": "CNAME instructions sent successfully",
            "ERROR_MESSAGE": "Error while sending CNAME instructions"
          }
        }
      },
      "EDIT": {
        "HEADER_TEXT": "Edytuj portal",
        "TABS": {
          "BASIC_SETTINGS": {
            "TITLE": "Podstawowe informacje"
          },
          "CUSTOMIZATION_SETTINGS": {
            "TITLE": "Dostosowanie portalu"
          },
          "CATEGORY_SETTINGS": {
            "TITLE": "Kategorie"
          },
          "LOCALE_SETTINGS": {
            "TITLE": "Języki"
          }
        },
        "CATEGORIES": {
          "TITLE": "Kategorie w",
          "NEW_CATEGORY": "Nowa kategoria",
          "TABLE": {
            "NAME": "Nazwa",
            "DESCRIPTION": "Opis",
            "LOCALE": "Język",
            "ARTICLE_COUNT": "Liczba artykułów",
            "ACTION_BUTTON": {
              "EDIT": "Edytuj kategorię",
              "DELETE": "Usuń kategorię"
            },
            "EMPTY_TEXT": "Nie znaleziono kategorii"
          }
        },
        "EDIT_BASIC_INFO": {
          "BUTTON_TEXT": "Zaktualizuj podstawowe ustawienia"
        }
      },
      "ADD": {
        "CREATE_FLOW": {
          "BASIC": {
            "TITLE": "Informacje o centrum pomocy",
            "BODY": "Podstawowe informacje o portalu"
          },
          "CUSTOMIZATION": {
            "TITLE": "Dostosowanie centrum pomocy",
            "BODY": "Dostosuj portal"
          },
          "FINISH": {
            "TITLE": "Gotowe! 🎉",
            "BODY": "Wszystko jest gotowe!"
          }
        },
        "CREATE_FLOW_PAGE": {
          "BACK_BUTTON": "Powrót",
          "BASIC_SETTINGS_PAGE": {
            "HEADER": "Utwórz portal",
            "TITLE": "Informacje o centrum pomocy",
            "CREATE_BASIC_SETTING_BUTTON": "Utwórz podstawowe ustawienia portalu"
          },
          "CUSTOMIZATION_PAGE": {
            "HEADER": "Dostosowanie portalu",
            "TITLE": "Dostosowanie centrum pomocy",
            "UPDATE_PORTAL_BUTTON": "Zaktualizuj ustawienia portalu"
          },
          "FINISH_PAGE": {
            "TITLE": "Gotowe!🎉 Wszystko jest gotowe!",
            "MESSAGE": "Możesz teraz zobaczyć utworzony portal na stronie z wszystkimi portalami.",
            "FINISH": "Przejdź do strony z wszystkimi portalami"
          }
        },
        "LOGO": {
          "LABEL": "Logo",
          "UPLOAD_BUTTON": "Prześlij logo",
          "HELP_TEXT": "To logo będzie wyświetlane w nagłówku portalu.",
          "IMAGE_UPLOAD_SUCCESS": "Logo uploaded successfully",
          "IMAGE_UPLOAD_ERROR": "Logo deleted successfully",
          "IMAGE_DELETE_ERROR": "Error while deleting logo"
        },
        "NAME": {
          "LABEL": "Nazwa",
          "PLACEHOLDER": "Nazwa portalu",
          "HELP_TEXT": "Nazwa będzie używana w publicznym portalu wewnętrznie.",
          "ERROR": "Nazwa jest wymagana"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug portalu dla adresów URL",
          "ERROR": "Slug jest wymagany"
        },
        "DOMAIN": {
          "LABEL": "Niestandardowa domena",
          "PLACEHOLDER": "Niestandardowa domena portalu",
          "HELP_TEXT": "Add only If you want to use a custom domain for your portals. Eg: {exampleURL}",
          "ERROR": "Podaj poprawny adres URL domeny"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Link do strony głównej",
          "PLACEHOLDER": "Link do strony głównej portalu",
          "HELP_TEXT": "The link used to return from the portal to the home page. Eg: {exampleURL}",
          "ERROR": "Podaj poprawny adres URL strony głównej"
        },
        "THEME_COLOR": {
          "LABEL": "Kolor motywu portalu",
          "HELP_TEXT": "Ten kolor będzie widoczny jako kolor motywu portalu."
        },
        "PAGE_TITLE": {
          "LABEL": "Tytuł strony",
          "PLACEHOLDER": "Tytuł strony portalu",
          "HELP_TEXT": "Tytuł strony będzie używany w publicznym portalu.",
          "ERROR": "Tytuł strony jest wymagany"
        },
        "HEADER_TEXT": {
          "LABEL": "Tekst nagłówka",
          "PLACEHOLDER": "Tekst nagłówka portalu",
          "HELP_TEXT": "Tekst nagłówka portalu będzie używany w publicznym portalu.",
          "ERROR": "Tekst nagłówka portalu jest wymagany"
        },
        "API": {
          "SUCCESS_MESSAGE_FOR_BASIC": "Portal utworzony pomyślnie.",
          "ERROR_MESSAGE_FOR_BASIC": "Nie udało się utworzyć portalu. Spróbuj ponownie.",
          "SUCCESS_MESSAGE_FOR_UPDATE": "Portal zaktualizowany pomyślnie.",
          "ERROR_MESSAGE_FOR_UPDATE": "Nie udało się zaktualizować portalu. Spróbuj ponownie."
        }
      },
      "ADD_LOCALE": {
        "TITLE": "Dodaj nowy język",
        "SUB_TITLE": "Dodaje nowy język do listy dostępnych tłumaczeń.",
        "PORTAL": "Portal",
        "LOCALE": {
          "LABEL": "Język",
          "PLACEHOLDER": "Wybierz język",
          "ERROR": "Język jest wymagany"
        },
        "BUTTONS": {
          "CREATE": "Utwórz język",
          "CANCEL": "Anuluj"
        },
        "API": {
          "SUCCESS_MESSAGE": "Język dodany pomyślnie",
          "ERROR_MESSAGE": "Nie można dodać języka. Spróbuj ponownie."
        }
      },
      "CHANGE_DEFAULT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Domyślny język zaktualizowany pomyślnie",
          "ERROR_MESSAGE": "Nie można zaktualizować domyślnego języka. Spróbuj ponownie."
        }
      },
      "DELETE_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Język usunięty z portalu pomyślnie",
          "ERROR_MESSAGE": "Nie można usunąć języka z portalu. Spróbuj ponownie."
        }
      },
      "DRAFT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Locale moved to draft successfully",
          "ERROR_MESSAGE": "Unable to move locale to draft. Try again."
        }
      },
      "PUBLISH_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Locale published successfully",
          "ERROR_MESSAGE": "Unable to publish locale. Try again."
        }
      }
    },
    "TABLE": {
      "LOADING_MESSAGE": "Ładowanie artykułów...",
      "404": "Nie znaleziono artykułów pasujących do wyszukiwania 🔍",
      "NO_ARTICLES": "Brak dostępnych artykułów",
      "HEADERS": {
        "TITLE": "Tytuł",
        "CATEGORY": "Kategoria",
        "READ_COUNT": "Views",
        "STATUS": "Status",
        "LAST_EDITED": "Ostatnio edytowane"
      },
      "COLUMNS": {
        "BY": "przez",
        "AUTHOR_NOT_AVAILABLE": "Author is not available"
      }
    },
    "EDIT_ARTICLE": {
      "LOADING": "Ładowanie artykułu...",
      "TITLE_PLACEHOLDER": "Tutaj wprowadź tytuł artykułu",
      "CONTENT_PLACEHOLDER": "Napisz tutaj treść artykułu",
      "API": {
        "ERROR": "Błąd podczas zapisywania artykułu"
      }
    },
    "PUBLISH_ARTICLE": {
      "API": {
        "ERROR": "Błąd podczas publikowania artykułu",
        "SUCCESS": "Artykuł opublikowany pomyślnie"
      }
    },
    "ARCHIVE_ARTICLE": {
      "API": {
        "ERROR": "Błąd podczas archiwizowania artykułu",
        "SUCCESS": "Artykuł zarchiwizowany pomyślnie"
      }
    },
    "DRAFT_ARTICLE": {
      "API": {
        "ERROR": "Error while drafting article",
        "SUCCESS": "Article drafted successfully"
      }
    },
    "DELETE_ARTICLE": {
      "MODAL": {
        "CONFIRM": {
          "TITLE": "Potwierdź usunięcie",
          "MESSAGE": "Czy na pewno chcesz usunąć ten artykuł?",
          "YES": "Tak, usuń",
          "NO": "Nie, zachowaj"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Artykuł pomyślnie usunięty",
        "ERROR_MESSAGE": "Błąd podczas usuwania artykułu"
      }
    },
    "REORDER_ARTICLE": {
      "API": {
        "ERROR_MESSAGE": "Unable to reorder articles. Please try again."
      }
    },
    "REORDER_CATEGORY": {
      "API": {
        "ERROR_MESSAGE": "Unable to reorder categories. Please try again."
      }
    },
    "CREATE_ARTICLE": {
      "ERROR_MESSAGE": "Proszę dodać tytuł i treść artykułu, aby móc zaktualizować ustawienia"
    },
    "SIDEBAR": {
      "SEARCH": {
        "PLACEHOLDER": "Wyszukaj artykułów"
      }
    },
    "CATEGORY": {
      "ADD": {
        "TITLE": "Utwórz kategorię",
        "SUB_TITLE": "Kategoria będzie używana w publicznym portalu do kategoryzacji artykułów.",
        "PORTAL": "Portal",
        "LOCALE": "Język",
        "NAME": {
          "LABEL": "Nazwa",
          "PLACEHOLDER": "Nazwa kategorii",
          "HELP_TEXT": "The category name and icon will be used in the public facing portal to categorize articles.",
          "ERROR": "Nazwa jest wymagana"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug kategorii dla adresów URL",
          "HELP_TEXT": "app.chatwoot.com/hc/my-portal/pl-PL/categories/my-slug",
          "ERROR": "Slug jest wymagany"
        },
        "DESCRIPTION": {
          "LABEL": "Opis",
          "PLACEHOLDER": "Krótki opis kategorii.",
          "ERROR": "Opis jest wymagany"
        },
        "BUTTONS": {
          "CREATE": "Utwórz kategorię",
          "CANCEL": "Anuluj"
        },
        "API": {
          "SUCCESS_MESSAGE": "Kategoria utworzona pomyślnie",
          "ERROR_MESSAGE": "Nie można utworzyć kategorii"
        }
      },
      "EDIT": {
        "TITLE": "Edytuj kategorię",
        "SUB_TITLE": "Edycja kategorii spowoduje aktualizację kategorii w publicznym portalu.",
        "PORTAL": "Portal",
        "LOCALE": "Język",
        "NAME": {
          "LABEL": "Nazwa",
          "PLACEHOLDER": "Nazwa kategorii",
          "HELP_TEXT": "The category name and icon will be used in the public facing portal to categorize articles.",
          "ERROR": "Nazwa jest wymagana"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug kategorii dla adresów URL",
          "HELP_TEXT": "app.chatwoot.com/hc/my-portal/pl-PL/categories/my-slug",
          "ERROR": "Slug jest wymagany"
        },
        "DESCRIPTION": {
          "LABEL": "Opis",
          "PLACEHOLDER": "Krótki opis kategorii.",
          "ERROR": "Opis jest wymagany"
        },
        "BUTTONS": {
          "CREATE": "Aktualizuj kategorię",
          "CANCEL": "Anuluj"
        },
        "API": {
          "SUCCESS_MESSAGE": "Kategoria zaktualizowana pomyślnie",
          "ERROR_MESSAGE": "Nie można zaktualizować kategorii"
        }
      },
      "DELETE": {
        "API": {
          "SUCCESS_MESSAGE": "Kategoria pomyślnie usunięta",
          "ERROR_MESSAGE": "Nie można usunąć kategorii"
        }
      }
    },
    "ARTICLE_SEARCH": {
      "TITLE": "Search articles",
      "PLACEHOLDER": "Search articles",
      "NO_RESULT": "Brak znalezionych artykułów",
      "SEARCHING": "Wyszukiwanie...",
      "SEARCH_BUTTON": "Szukaj",
      "INSERT_ARTICLE": "Insert link",
      "IFRAME_ERROR": "URL is empty or invalid. Unable to display content.",
      "OPEN_ARTICLE_SEARCH": "Insert article from Help Center",
      "SUCCESS_ARTICLE_INSERTED": "Article inserted successfully",
      "PREVIEW_LINK": "Podgląd artykułu",
      "CANCEL": "Zamknij",
      "BACK": "Powrót",
      "BACK_RESULTS": "Back to results"
    },
    "UPGRADE_PAGE": {
      "TITLE": "Centrum pomocy",
      "DESCRIPTION": "Create user-friendly self-service portals. Help your users to access the articles and get support 24/7. Upgrade your subscription to enable this feature.",
      "SELF_HOSTED_DESCRIPTION": "Create user-friendly self-service portals. Help your users to access the articles and get support 24/7. Please contact your administrator to enable this feature.",
      "BUTTON": {
        "LEARN_MORE": "Dowiedz się więcej",
        "UPGRADE": "Upgrade"
      },
      "FEATURES": {
        "PORTALS": {
          "TITLE": "Multiple portals",
          "DESCRIPTION": "Create multiple help center portals for different products using the same account."
        },
        "LOCALES": {
          "TITLE": "Full support for locales",
          "DESCRIPTION": "Localize the portal in your language. We support all locales and allow translations for every article."
        },
        "SEO": {
          "TITLE": "SEO-friendly design",
          "DESCRIPTION": "Customize your meta tags to improve your visibility on search engines with our SEO-friendly pages."
        },
        "API": {
          "TITLE": "Full API support",
          "DESCRIPTION": "Use the portal as a headless CMS with third party front-end frameworks using our APIs."
        }
      }
    },
    "LOADING": "Loading...",
    "ARTICLES_PAGE": {
      "ARTICLE_CARD": {
        "CARD": {
          "VIEWS": "{count} view | {count} views",
          "DROPDOWN_MENU": {
            "PUBLISH": "Opublikuj",
            "DRAFT": "Szkic",
            "ARCHIVE": "Archive",
            "TRANSLATE": "Przetłumacz",
            "DELETE": "Usuń"
          },
          "STATUS": {
            "DRAFT": "Szkic",
            "PUBLISHED": "Opublikowane",
            "ARCHIVED": "Zarchiwizowane"
          },
          "PENDING_EDITS": "Unpublished edits",
          "PENDING_EDITS_TOOLTIP": "This published article has unpublished edits",
          "CATEGORY": {
            "UNCATEGORISED": "Uncategorised"
          }
        }
      },
      "ARTICLES_HEADER": {
        "TABS": {
          "ALL": "All articles",
          "MINE": "Moje",
          "DRAFT": "Szkic",
          "PUBLISHED": "Opublikowane",
          "ARCHIVED": "Zarchiwizowane"
        },
        "CATEGORY": {
          "ALL": "All categories"
        },
        "LOCALE": {
          "ALL": "All locales"
        },
        "SEARCH_PLACEHOLDER": "Search articles...",
        "NEW_ARTICLE": "New article"
      },
      "EMPTY_STATE": {
        "ALL": {
          "TITLE": "Write an article",
          "SUBTITLE": "Write a rich article, let’s get started!",
          "BUTTON_LABEL": "New article"
        },
        "MINE": {
          "TITLE": "You haven't written any articles here",
          "SUBTITLE": "All articles written by you show up here for quick access."
        },
        "DRAFT": {
          "TITLE": "There are no articles in drafts",
          "SUBTITLE": "Draft articles will appear here"
        },
        "PUBLISHED": {
          "TITLE": "There are no published articles",
          "SUBTITLE": "Published articles will appear here"
        },
        "ARCHIVED": {
          "TITLE": "There are no articles in the archive",
          "SUBTITLE": "Archived articles don't show up on the portal, you can use it to mark deprecated or outdated pages"
        },
        "CATEGORY": {
          "TITLE": "There are no articles in this category",
          "SUBTITLE": "Articles in this category will appear here"
        },
        "SEARCH": {
          "TITLE": "No matching articles",
          "SUBTITLE": "We couldn't find any articles matching your search. Try a different term."
        }
      },
      "BULK_TRANSLATE": {
        "TITLE": "Translate article | Translate {count} articles",
        "DESCRIPTION": "Translate the selected article to another language. | Translate the selected articles to another language.",
        "LOCALE_LABEL": "Target language",
        "LOCALE_PLACEHOLDER": "Select a language",
        "CATEGORY_LABEL": "Target category",
        "CATEGORY_PLACEHOLDER": "Select a category",
        "OPTIONAL": "(optional)",
        "CONFIRM": "Przetłumacz",
        "SELECT_ALL": "Select all ({count})",
        "SELECTED_COUNT": "{count} selected",
        "CLEAR_SELECTION": "Clear selection",
        "TRANSLATE_BUTTON": "Przetłumacz",
        "CONFIRM_OVERWRITE": "Overwrite and translate",
        "DUPLICATE_WARNING": "A translation already exists for this article in the selected language. | Translations already exist for {count} articles in the selected language.",
        "DUPLICATE_CONFIRM_HINT": "Click translate again to overwrite the existing translation.",
        "API": {
          "SUCCESS_MESSAGE": "Translation in progress. The article will appear as a draft once ready.",
          "ERROR_MESSAGE": "Failed to start translation. Please try again."
        }
      },
      "BULK_ACTIONS": {
        "PUBLISH": "Opublikuj",
        "DRAFT": "Szkic",
        "ARCHIVE": "Archive",
        "TRANSLATE": "Przetłumacz",
        "MOVE_TO_CATEGORY": "Kategoria",
        "DELETE": "Usuń",
        "STATUS_SUCCESS": "Articles updated successfully",
        "STATUS_ERROR": "Failed to update articles",
        "STATUS_SKIPPED": "1 article with unpublished edits was skipped — open it to publish or discard. | {count} articles with unpublished edits were skipped — open them to publish or discard.",
        "STATUS_SKIPPED_ALL": "These articles have unpublished edits — open each to publish or discard.",
        "CATEGORY_SUCCESS": "Articles moved successfully",
        "CATEGORY_ERROR": "Failed to move articles",
        "DELETE_CONFIRM_TITLE": "Delete article | Delete {count} articles",
        "DELETE_CONFIRM_DESCRIPTION": "This will permanently delete the selected article. This action cannot be undone. | This will permanently delete {count} selected articles. This action cannot be undone.",
        "DELETE_CONFIRM": "Usuń",
        "DELETE_SUCCESS": "Articles deleted successfully",
        "DELETE_ERROR": "Failed to delete articles"
      }
    },
    "CATEGORY_PAGE": {
      "CATEGORY_HEADER": {
        "NEW_CATEGORY": "Nowa kategoria",
        "EDIT_CATEGORY": "Edytuj kategorię",
        "SEARCH_PLACEHOLDER": "Search categories...",
        "CATEGORIES_COUNT": "{n} category | {n} categories",
        "BREADCRUMB": {
          "CATEGORY_LOCALE": "Categories ({localeCode})",
          "ACTIVE_CATEGORY": "{categoryName} ({categoryCount} articles) | {categoryName} ({categoryCount} article)"
        }
      },
      "CATEGORY_EMPTY_STATE": {
        "TITLE": "Nie znaleziono kategorii",
        "SUBTITLE": "Categories will appear here. You can add a category by clicking the 'New Category' button."
      },
      "SEARCH_EMPTY_STATE": {
        "TITLE": "No matching categories",
        "SUBTITLE": "We couldn't find any categories matching your search. Try a different term."
      },
      "CATEGORY_CARD": {
        "ARTICLES_COUNT": "{count} article | {count} articles"
      },
      "CATEGORY_DIALOG": {
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Kategoria utworzona pomyślnie",
            "ERROR_MESSAGE": "Nie można utworzyć kategorii"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Kategoria zaktualizowana pomyślnie",
            "ERROR_MESSAGE": "Nie można zaktualizować kategorii"
          }
        },
        "DELETE": {
          "API": {
            "SUCCESS_MESSAGE": "Kategoria pomyślnie usunięta",
            "ERROR_MESSAGE": "Nie można usunąć kategorii"
          }
        },
        "HEADER": {
          "CREATE": "Utwórz kategorię",
          "EDIT": "Edytuj kategorię",
          "DESCRIPTION": "Edycja kategorii spowoduje aktualizację kategorii w publicznym portalu.",
          "PORTAL": "Portal",
          "LOCALE": "Język"
        },
        "FORM": {
          "NAME": {
            "LABEL": "Imię",
            "PLACEHOLDER": "Nazwa kategorii",
            "ERROR": "Nazwa jest wymagana"
          },
          "SLUG": {
            "LABEL": "Slug",
            "PLACEHOLDER": "Slug kategorii dla adresów URL",
            "ERROR": "Slug jest wymagany",
            "HELP_TEXT": "app.chatwoot.com/hc/{portalSlug}/{localeCode}/categories/{categorySlug}"
          },
          "DESCRIPTION": {
            "LABEL": "Opis",
            "PLACEHOLDER": "Krótki opis kategorii.",
            "ERROR": "Opis jest wymagany"
          }
        },
        "BUTTONS": {
          "CREATE": "Stwórz",
          "EDIT": "Aktualizuj",
          "CANCEL": "Anuluj"
        }
      }
    },
    "LOCALES_PAGE": {
      "LOCALES_COUNT": "No locales available | {n} locale | {n} locales",
      "NEW_LOCALE_BUTTON_TEXT": "New locale",
      "SEARCH_PLACEHOLDER": "Search locales...",
      "SEARCH_EMPTY_STATE": {
        "TITLE": "No matching locales",
        "SUBTITLE": "We couldn't find any locales matching your search. Try a different term."
      },
      "LOCALE_CARD": {
        "ARTICLES_COUNT": "{count} article | {count} articles",
        "CATEGORIES_COUNT": "{count} category | {count} categories",
        "DEFAULT": "Domyślny",
        "DRAFT": "Szkic",
        "DROPDOWN_MENU": {
          "MAKE_DEFAULT": "Make default",
          "MOVE_TO_DRAFT": "Move to draft",
          "PUBLISH_LOCALE": "Publish locale",
          "CUSTOMIZE_CONTENT": "Localize content",
          "SELECT_POPULAR_CONTENT": "Select recommended content",
          "DELETE": "Usuń"
        }
      },
      "POPULAR_CONTENT_DIALOG": {
        "TITLE": "Recommended content",
        "DESCRIPTION": "Pick up to 3 categories and 6 articles to feature on this locale's help center home page. Drag them into the order you want visitors to see.",
        "SEARCH": "Search...",
        "EMPTY": "No matching results",
        "ADD_ANOTHER": "Add another...",
        "SLOTS_LEFT": "{count} slots left",
        "OVERRIDING_DEFAULTS": "Overriding defaults for this locale",
        "CONFIRM": "Save recommendations",
        "CATEGORIES": {
          "LABEL": "Recommended categories",
          "ARTICLES_COUNT": "No articles | {count} article | {count} articles"
        },
        "ARTICLES": {
          "LABEL": "Recommended articles",
          "IN_CATEGORY": "in {category}",
          "UNCATEGORIZED": "Bez kategorii"
        },
        "API": {
          "SUCCESS_MESSAGE": "Recommended content updated successfully",
          "ERROR_MESSAGE": "Unable to update recommended content. Try again."
        }
      },
      "CONTENT_DIALOG": {
        "TITLE": "Localize content",
        "DESCRIPTION": "Set values specific to this locale. Anything left blank falls back to the default locale.",
        "NAME": {
          "LABEL": "Imię"
        },
        "PAGE_TITLE": {
          "LABEL": "Page title"
        },
        "HEADER_TEXT": {
          "LABEL": "Header text"
        },
        "API": {
          "SUCCESS_MESSAGE": "Locale content updated successfully",
          "ERROR_MESSAGE": "Unable to update locale content. Try again."
        }
      },
      "ADD_LOCALE_DIALOG": {
        "TITLE": "Dodaj nowy język",
        "DESCRIPTION": "Select the language in which this article will be written. This will be added to your list of translations, and you can add more later.",
        "COMBOBOX": {
          "PLACEHOLDER": "Select locale..."
        },
        "STATUS": {
          "LABEL": "Status",
          "OPTIONS": {
            "LIVE": "Opublikowane",
            "DRAFT": "Szkic"
          }
        },
        "API": {
          "SUCCESS_MESSAGE": "Język dodany pomyślnie",
          "ERROR_MESSAGE": "Nie można dodać języka. Spróbuj ponownie."
        }
      }
    },
    "EDIT_ARTICLE_PAGE": {
      "HEADER": {
        "STATUS": {
          "SAVING": "Zapisywanie...",
          "SAVED": "Zapisano"
        },
        "PREVIEW": "Podgląd",
        "PUBLISH": "Opublikuj",
        "PUBLISH_CHANGES": "Publish changes",
        "PUBLISH_CHANGES_SUCCESS": "Changes published successfully",
        "PUBLISH_CHANGES_ERROR": "Could not publish changes",
        "SAVE_IN_PROGRESS": "Still saving your latest changes — please try again in a moment.",
        "DISCARD_CHANGES": "Discard changes",
        "DISCARD_CHANGES_SUCCESS": "Changes discarded",
        "DISCARD_CHANGES_ERROR": "Could not discard changes",
        "PENDING_CHANGES": "Pending changes",
        "VIEW_CHANGES": "View unpublished changes",
        "DRAFT": "Szkic",
        "ARCHIVE": "Archive",
        "BACK_TO_ARTICLES": "Back to articles"
      },
      "PENDING_CHANGES_POPOVER": {
        "TITLE": "Unpublished changes",
        "DESCRIPTION": "This article has draft changes that aren't live yet. Apply them before changing the status, or discard them?",
        "APPLY": "Apply changes",
        "DISCARD": "Discard changes"
      },
      "DIFF_DIALOG": {
        "TITLE": "Unpublished changes",
        "DESCRIPTION": "Compare your draft against the version that's currently live.",
        "TITLE_LABEL": "Tytuł"
      },
      "EDIT_ARTICLE": {
        "MORE_PROPERTIES": "More properties",
        "UNCATEGORIZED": "Bez kategorii",
        "EDITOR_PLACEHOLDER": "Write something..."
      },
      "ARTICLE_PROPERTIES": {
        "ARTICLE_PROPERTIES": "Article properties",
        "META_DESCRIPTION": "Opis meta",
        "META_DESCRIPTION_PLACEHOLDER": "Add meta description",
        "META_TITLE": "Tytuł meta",
        "META_TITLE_PLACEHOLDER": "Add meta title",
        "META_TAGS": "Tagi meta",
        "META_TAGS_PLACEHOLDER": "Add meta tags"
      },
      "API": {
        "ERROR": "Błąd podczas zapisywania artykułu"
      }
    },
    "PORTAL_SWITCHER": {
      "NEW_PORTAL": "New portal",
      "PORTALS": "Portale",
      "CREATE_PORTAL": "Create and manage multiple portals",
      "ARTICLES": "artykułów",
      "DOMAIN": "domena",
      "PORTAL_NAME": "Nazwa portalu"
    },
    "CREATE_PORTAL_DIALOG": {
      "TITLE": "Create new portal",
      "DESCRIPTION": "Give your portal a name and create a user-friendly URL slug. You can modify both later in the settings.",
      "CONFIRM_BUTTON_LABEL": "Stwórz",
      "NAME": {
        "LABEL": "Imię",
        "PLACEHOLDER": "User Guide | Chatwoot",
        "MESSAGE": "Choose an name for your portal.",
        "ERROR": "Nazwa jest wymagana"
      },
      "SLUG": {
        "LABEL": "Slug",
        "PLACEHOLDER": "user-guide",
        "ERROR": "Slug jest wymagany",
        "FORMAT_ERROR": "Please enter a valid slug, for eg: user-guide"
      }
    },
    "PORTAL_SETTINGS": {
      "FORM": {
        "AVATAR": {
          "LABEL": "Logo",
          "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
          "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save changes to save the logo",
          "IMAGE_DELETE_SUCCESS": "Logo deleted successfully",
          "IMAGE_DELETE_ERROR": "Unable to delete logo",
          "IMAGE_UPLOAD_SIZE_ERROR": "Rozmiar obrazu powinien być mniejszy niż {size}MB"
        },
        "NAME": {
          "LABEL": "Imię",
          "PLACEHOLDER": "Nazwa portalu",
          "ERROR": "Nazwa jest wymagana"
        },
        "HEADER_TEXT": {
          "LABEL": "Header text",
          "PLACEHOLDER": "Tekst nagłówka portalu"
        },
        "PAGE_TITLE": {
          "LABEL": "Page title",
          "PLACEHOLDER": "Tytuł strony portalu"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Home page link",
          "PLACEHOLDER": "Link do strony głównej portalu",
          "ERROR": "Enter a valid URL. The Home page link must start with 'http://' or 'https://'."
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Portal slug"
        },
        "LIVE_CHAT_WIDGET": {
          "LABEL": "Live chat widget",
          "PLACEHOLDER": "Select live chat widget",
          "HELP_TEXT": "Select a live chat widget that will appear on your help center",
          "NONE_OPTION": "No widget"
        },
        "BRAND_COLOR": {
          "LABEL": "Brand color"
        },
        "SAVE_CHANGES": "Save changes"
      },
      "CONFIGURATION_FORM": {
        "CUSTOM_DOMAIN": {
          "HEADER": "Niestandardowa domena",
          "LABEL": "Niestandardowa domena:",
          "DESCRIPTION": "You can host your portal on a custom domain. For instance, if your website is yourdomain.com and you want your portal available at docs.yourdomain.com, simply enter that in this field.",
          "STATUS_DESCRIPTION": "Your custom portal will start working as soon as it is verified.",
          "PLACEHOLDER": "Niestandardowa domena portalu",
          "EDIT_BUTTON": "Edytuj",
          "ADD_BUTTON": "Add custom domain",
          "STATUS": {
            "LIVE": "Na żywo",
            "PENDING": "Awaiting verification",
            "ERROR": "Verification failed"
          },
          "DIALOG": {
            "ADD_HEADER": "Add custom domain",
            "EDIT_HEADER": "Edit custom domain",
            "ADD_CONFIRM_BUTTON_LABEL": "Add domain",
            "EDIT_CONFIRM_BUTTON_LABEL": "Update domain",
            "LABEL": "Niestandardowa domena",
            "PLACEHOLDER": "Niestandardowa domena portalu",
            "ERROR": "Custom domain is required",
            "FORMAT_ERROR": "Please enter a valid domain URL e.g. docs.yourdomain.com"
          },
          "DNS_CONFIGURATION_DIALOG": {
            "HEADER": "DNS configuration",
            "DESCRIPTION": "Log in to the account you have with your DNS provider, and add a CNAME record for subdomain pointing to chatwoot.help",
            "COPY": "Successfully copied CNAME",
            "SEND_INSTRUCTIONS": {
              "HEADER": "Send instructions",
              "DESCRIPTION": "If you would prefer to have someone from your development team to handle this step, you can enter email address below, and we will send them the required instructions.",
              "PLACEHOLDER": "Enter their email",
              "ERROR": "Enter a valid email address",
              "SEND_BUTTON": "Wyślij"
            }
          }
        },
        "DELETE_PORTAL": {
          "BUTTON": "Delete {portalName}",
          "HEADER": "Usuń portal",
          "DESCRIPTION": "Permanently delete this portal. This action is irreversible",
          "DIALOG": {
            "HEADER": "Sure you want to delete {portalName}?",
            "DESCRIPTION": "This is a permanent action that cannot be reversed.",
            "CONFIRM_BUTTON_LABEL": "Usuń"
          }
        },
        "EDIT_CONFIGURATION": "Edit configuration"
      },
      "LAYOUT_CONTENT": {
        "HEADER": "Appearance",
        "DESCRIPTION": "Pick the layout that fits how your visitors read.",
        "LAYOUT": {
          "CLASSIC": {
            "TITLE": "Classic",
            "DESCRIPTION": "A welcoming home page with search and featured topics."
          },
          "SIDEBAR": {
            "TITLE": "Documentation",
            "DESCRIPTION": "Side-by-side navigation that keeps every guide a click away."
          }
        },
        "SOCIAL_LINKS": {
          "HEADER": "Social links",
          "DESCRIPTION": "Add the handle for each network and your help center builds the full link. Shown in the documentation layout footer.",
          "PLACEHOLDER": "handle",
          "ADD": "Add social link",
          "REMOVE": "Usuń"
        },
        "SAVE": "Save changes"
      },
      "API": {
        "CREATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portal utworzony pomyślnie",
          "ERROR_MESSAGE": "Unable to create portal"
        },
        "UPDATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portal zaktualizowany pomyślnie",
          "ERROR_MESSAGE": "Unable to update portal"
        }
      }
    },
    "PDF_UPLOAD": {
      "TITLE": "Upload PDF Document",
      "DESCRIPTION": "Upload a PDF document to automatically generate FAQs using AI",
      "DRAG_DROP_TEXT": "Drag and drop your PDF file here, or click to select",
      "SELECT_FILE": "Select PDF File",
      "ADDITIONAL_CONTEXT_LABEL": "Additional Context (Optional)",
      "ADDITIONAL_CONTEXT_PLACEHOLDER": "Provide any additional context or instructions for FAQ generation...",
      "UPLOADING": "Przesyłanie...",
      "UPLOAD": "Upload & Process",
      "CANCEL": "Anuluj",
      "ERROR_INVALID_TYPE": "Please select a valid PDF file",
      "ERROR_FILE_TOO_LARGE": "File size must be less than 512MB",
      "ERROR_UPLOAD_FAILED": "Failed to upload PDF. Please try again."
    },
    "PDF_DOCUMENTS": {
      "TITLE": "PDF Documents",
      "DESCRIPTION": "Manage uploaded PDF documents and generate FAQs from them",
      "UPLOAD_PDF": "Upload PDF",
      "UPLOAD_FIRST_PDF": "Upload your first PDF",
      "UPLOADED_BY": "Uploaded by",
      "GENERATE_FAQS": "Generate FAQs",
      "GENERATING": "Generowanie...",
      "CONFIRM_DELETE": "Are you sure you want to delete {filename}?",
      "EMPTY_STATE": {
        "TITLE": "No PDF documents yet",
        "DESCRIPTION": "Upload PDF documents to automatically generate FAQs using AI"
      },
      "STATUS": {
        "UPLOADED": "Ready",
        "PROCESSING": "Processing",
        "PROCESSED": "Zakończone",
        "FAILED": "Failed"
      }
    },
    "CONTENT_GENERATION": {
      "TITLE": "Content Generation",
      "DESCRIPTION": "Upload PDF documents to automatically generate FAQ content using AI",
      "UPLOAD_TITLE": "Upload PDF Document",
      "DRAG_DROP": "Drag and drop your PDF file here, or click to select",
      "SELECT_FILE": "Select PDF File",
      "UPLOADING": "Processing document...",
      "UPLOAD_SUCCESS": "Document processed successfully!",
      "UPLOAD_ERROR": "Failed to upload document. Please try again.",
      "INVALID_FILE_TYPE": "Please select a valid PDF file",
      "FILE_TOO_LARGE": "File size must be less than 512MB",
      "GENERATED_CONTENT": "Generated FAQ Content",
      "PUBLISH_SELECTED": "Publish Selected",
      "PUBLISHING": "Publishing...",
      "FROM_DOCUMENT": "From document",
      "NO_CONTENT": "No generated content available. Upload a PDF document to get started.",
      "LOADING": "Loading generated content..."
    }
  }
}
